"use client";
import { jsxs as h, jsx as a } from "react/jsx-runtime";
const t = ({
  title: l,
  titleId: c,
  desc: e,
  descId: i,
  ...r
}) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": c,
    "aria-describedby": i,
    ...r,
    children: [
      e ? /* @__PURE__ */ a("desc", { id: i, children: e }) : null,
      l ? /* @__PURE__ */ a("title", { id: c, children: l }) : null,
      /* @__PURE__ */ a("path", { d: "M31.25 15.652V10a4.587 4.587 0 0 0-4.583-4.583H24.29a2.913 2.913 0 0 0-2.623-1.667H15a2.913 2.913 0 0 0-2.623 1.667H10A4.587 4.587 0 0 0 5.417 10v21.667A4.587 4.587 0 0 0 10 36.25h15c6.204 0 11.25-5.047 11.25-11.25 0-3.892-1.988-7.327-5-9.348M14.584 6.667c0-.23.186-.417.416-.417h6.667c.23 0 .417.187.417.417v1.666c0 .23-.187.417-.417.417H15a.417.417 0 0 1-.416-.417zM10 33.75a2.086 2.086 0 0 1-2.083-2.083V10c0-1.148.935-2.083 2.083-2.083h2.084v.416A2.92 2.92 0 0 0 15 11.25h6.667a2.92 2.92 0 0 0 2.917-2.917v-.416h2.083c1.148 0 2.083.935 2.083 2.083v4.407A11.19 11.19 0 0 0 25 13.75c-6.203 0-11.25 5.047-11.25 11.25 0 3.532 1.64 6.687 4.195 8.75zm15 0c-4.825 0-8.75-3.925-8.75-8.75s3.925-8.75 8.75-8.75 8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m5.884-11.2-6.077 6.077a2.07 2.07 0 0 1-1.473.608 2.07 2.07 0 0 1-1.474-.608l-2.743-2.744a1.25 1.25 0 0 1 1.768-1.768l2.45 2.45 5.784-5.783a1.25 1.25 0 1 1 1.768 1.768z" })
    ]
  }
);
export {
  t as default
};
